import React from "react";
import { formatDate, tz } from "@backpacker/date";
import DateFromNow from "@backpacker/date/from-now";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import Tooltip from "@ui-kit/tooltip";
import { Post, PostLensFactory } from "@radarly/models/posts";

interface IProps {
  post: Post;
  timezone: Timezone;
  locale: Locale;
  className?: string;
  isTooltipDisabled?: boolean;
}

const RadarlyPostDate = ({
  post,
  timezone,
  locale,
  className,
  isTooltipDisabled = false,
}: IProps) => {
  const lens = PostLensFactory.create(post);
  const permalink = lens.getPermalink();
  const fromNow = (
    <DateFromNow date={post.date} locale={locale} timezone={timezone} />
  );

  return (
    <Tooltip
      disabled={isTooltipDisabled}
      tooltip={formatDate(tz(post.date, timezone), locale, "LL - LT")}
    >
      {permalink ? (
        <a
          className={className}
          href={permalink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {fromNow}
        </a>
      ) : (
        <span>{fromNow}</span>
      )}
    </Tooltip>
  );
};

export default RadarlyPostDate;
